import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {MyCheckComponent} from "./my-check.component";


@NgModule({
	imports: [CommonModule],
	declarations: [
		MyCheckComponent,
	],
	exports: [
		MyCheckComponent
	]
})
export class MyCheckModule {}